import { Box, Typography } from '@mui/material'
import { EditorContent, JSONContent, useEditor } from '@tiptap/react'
import { FC, useEffect } from 'react'
import { buildDocExtensions } from './editorExtensions'
import { proseSx } from './editorStyles'

interface RichTextRendererProps {
  content?: JSONContent | null
  emptyText?: string
}

/** Read-only render of a stored doc document, visually identical to the editor. */
export const RichTextRenderer: FC<RichTextRendererProps> = ({ content, emptyText }) => {
  const editor = useEditor({
    editable: false,
    extensions: buildDocExtensions(),
    content: content || '',
  })

  useEffect(() => {
    if (editor && content) {
      editor.commands.setContent(content)
    }
  }, [editor, content])

  const isEmpty = !content || !(content as JSONContent)?.content?.length

  if (isEmpty) {
    return (
      <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
        {emptyText || 'This page has no content yet.'}
      </Typography>
    )
  }

  return (
    <Box sx={proseSx}>
      <EditorContent editor={editor} />
    </Box>
  )
}
